import { render, staticRenderFns } from "./testListOld.vue?vue&type=template&id=748edff9&scoped=true&"
import script from "./testListOld.vue?vue&type=script&lang=js&"
export * from "./testListOld.vue?vue&type=script&lang=js&"
import style0 from "./testListOld.vue?vue&type=style&index=0&id=748edff9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748edff9",
  null
  
)

export default component.exports